// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-PublicChannelLayout-module__icon-stu2b {
  padding: 2px;
}

.nightbot-PublicChannelLayout-module__arrowIcon-t1o5a {
  transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/layouts/PublicChannelLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".icon {\n  padding: 2px;\n}\n\n.arrowIcon {\n  transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `nightbot-PublicChannelLayout-module__icon-stu2b`,
	"arrowIcon": `nightbot-PublicChannelLayout-module__arrowIcon-t1o5a`
};
export default ___CSS_LOADER_EXPORT___;
